import React, { useState } from "react";
import { Dropdown, Grid, Icon, InputCheckbox, Text } from "~/components-shared";
import moment from "moment";
import styled, { useTheme } from "styled-components";
import { useDispatch } from "react-redux";
import topicActionCreators from "~/store/topics/actions";
import { AuthoritiesEnum } from "~/types/enums";
import { TopicActionEnum } from "~/store/topics/types";
import useAbacExt from "~/hooks/abac";
import { useTranslation } from "react-i18next";
const Timeline = styled.div`
  position: relative;
  width: 6px;
  height: 100%;

  &:before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: ${_ref => {
  let {
    $color
  } = _ref;
  return $color;
}};
    border-radius: 50%;
    outline: 2px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.background.primary;
}};
    left: -2px;
    top: 1rem;
    z-index: 1;
  }
`;
const Line = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0);
  width: 6px;
  height: 1000000px;
  right: 0;
  top: 1rem;
  z-index: 1;
  transition: background-color 300ms ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: ${_ref3 => {
  let {
    $color
  } = _ref3;
  return $color;
}}33;
  }

  &:after {
    content: "";
    background-color: ${_ref4 => {
  let {
    $color
  } = _ref4;
  return $color;
}};
    position: absolute;
    width: 2px;
    height: 100%;
    left: 2px;
    top: 0;
  }
`;
const Actions = styled.div`
  margin-right: 10px;
`;
const TopicFootprintTarget = _ref5 => {
  let {
    topicId,
    target
  } = _ref5;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const {
    checkedAt,
    date,
    name,
    id,
    color,
    endsAt
  } = target;
  const endsAtTs = moment(endsAt).valueOf();
  const currentTs = moment().valueOf();
  const {
    userHas
  } = useAbacExt();
  let status;
  const handleCheck = () => {
    dispatch(topicActionCreators.checkTargetStarted(topicId, id, !checkedAt));
  };
  const handleUpdateComplete = () => {
    dispatch(topicActionCreators.actionChanged(TopicActionEnum.UPDATE_TARGET_COMPLETE, topicId, target));
  };
  if (checkedAt) {
    const checkedAtTs = moment(checkedAt).valueOf();
    if (checkedAtTs < endsAtTs) {
      const diff = moment.duration(endsAtTs - checkedAtTs, "ms").humanize();
      status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        scale: 4,
        s: {
          mr: 2,
          mt: -1
        },
        src: "checkboxFill",
        color: colors.success.main
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: 4,
        weight: "semiBold"
      }, "Completed in time"), /*#__PURE__*/React.createElement(Text, {
        display: "block",
        lineHeight: 6
      }, diff, " ahead planned"));
    } else if (checkedAtTs > endsAtTs) {
      const diff = moment.duration(endsAtTs - checkedAtTs, "ms").humanize();
      status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        scale: 4,
        s: {
          mr: 2,
          mt: -1
        },
        src: "checkboxFill",
        color: colors.danger.main
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: 4,
        weight: "semiBold"
      }, "Exceeded target"), /*#__PURE__*/React.createElement(Text, {
        display: "block",
        lineHeight: 6
      }, diff, " later than planned"));
    } else {
      status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        scale: 4,
        s: {
          mr: 2,
          mt: -1
        },
        src: "checkboxFill",
        color: colors.success.main
      }), /*#__PURE__*/React.createElement(Text, {
        fontSize: 4,
        weight: "semiBold"
      }, "Completed in time"), /*#__PURE__*/React.createElement(Text, {
        display: "block",
        lineHeight: 6
      }, "Within defined time frame"));
    }
  } else if (currentTs < endsAtTs) {
    const diff = moment.duration(endsAtTs - currentTs, "ms").humanize();
    status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      scale: 4,
      s: {
        mr: 2,
        mt: -1
      },
      src: "target"
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      weight: "semiBold"
    }, "Pending"), /*#__PURE__*/React.createElement(Text, {
      display: "block",
      lineHeight: 6
    }, "Starts in ", diff));
  } else if (currentTs > endsAtTs) {
    const diff = moment.duration(endsAtTs - currentTs, "ms").humanize();
    status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      scale: 4,
      s: {
        mr: 2,
        mt: -1
      },
      src: "target",
      color: colors.danger.main
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      weight: "semiBold",
      color: colors.danger.main
    }, "Ongoing"), /*#__PURE__*/React.createElement(Text, {
      display: "block",
      lineHeight: 6
    }, "Exceeded by ", diff));
  } else {
    status = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      scale: 4,
      s: {
        mr: 2,
        mt: -1
      },
      src: "target"
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      weight: "semiBold"
    }, "Ongoing"));
  }
  return /*#__PURE__*/React.createElement(Grid, {
    className: `topic__footprint-target${isHovered ? " topic__footprint--hovered" : ""}`,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    cols: 4,
    gap: 6,
    template: "200px 6px 1fr auto",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    align: "right",
    s: {
      mt: 2
    }
  }, status, checkedAt && /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    align: "right"
  }, moment(date).format("ddd, MMM D hh:mma"))), /*#__PURE__*/React.createElement(Timeline, {
    $color: color
  }, /*#__PURE__*/React.createElement(Line, {
    $color: color,
    "data-tooltip-float": true,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": name
  })), /*#__PURE__*/React.createElement(Grid.Cell, null, userHas(AuthoritiesEnum.TOPICS_WRITE) ? /*#__PURE__*/React.createElement(InputCheckbox, {
    value: !!checkedAt,
    onChange: handleCheck,
    color: color,
    label: /*#__PURE__*/React.createElement(Text, {
      element: "h4",
      s: {
        mt: -0.5
      }
    }, name),
    s: {
      my: 0.5
    }
  }) : /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    s: {
      mt: 1
    }
  }, name)), /*#__PURE__*/React.createElement(Actions, {
    className: "topic__footprint-actions"
  }, userHas(AuthoritiesEnum.TOPICS_WRITE) && /*#__PURE__*/React.createElement(Dropdown, {
    direction: "bottomLeft",
    handlerProps: {
      s: {
        p: 2,
        mt: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.options")
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      src: "dots-vertical",
      display: "block",
      color: colors.text.primary
    })
  }, _ref6 => {
    let {
      isOpen,
      onItemClick
    } = _ref6;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, userHas(AuthoritiesEnum.TOPICS_WRITE) && /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        handleUpdateComplete();
        onItemClick();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "pencil",
      scale: 4.5,
      s: {
        mr: 2
      },
      color: "primary"
    }), t("common.actions.edit")));
  })));
};
export default TopicFootprintTarget;